/** Clés i18n du studio BI institution (FR / EN + fallback anglais pour les autres locales). */

export const institutionBiStringsFr: Record<string, string> = {
  'institution.learnerAnalytics.biStudioBanner':
    'Cet écran est une vue standard. Pour créer vos propres tableaux (plusieurs dashboards, graphiques au choix, paramètres avancés), ouvrez le studio BI dans le menu de gauche : onglet « Tableaux BI », juste sous « Analyse apprenants ».',
  'institution.learnerAnalytics.openBiStudio': 'Ouvrir le studio BI — mes tableaux',
  'institution.bi.title': 'Tableaux de bord analytiques',
  'institution.bi.subtitle':
    'Créez plusieurs tableaux et composez graphiques et tableaux à partir des données de votre établissement (jeux de données sécurisés).',
  'institution.bi.loadError': 'Impossible de charger la BI.',
  'institution.bi.dataError': 'Impossible de charger les données du tableau.',
  'institution.bi.defaultDashboardTitle': 'Nouveau tableau',
  'institution.bi.createError': 'Création impossible.',
  'institution.bi.deleteError': 'Suppression impossible.',
  'institution.bi.confirmDeleteDashboard': 'Supprimer ce tableau de bord ?',
  'institution.bi.toast.dashboardRemoved': 'Tableau supprimé.',
  'institution.bi.toast.widgetRemoved': 'Graphique retiré du tableau.',
  'institution.bi.renameError': 'Enregistrement impossible.',
  'institution.bi.widgetAddError': 'Ajout du widget impossible.',
  'institution.bi.confirmDeleteWidget': 'Supprimer ce graphique ?',
  'institution.bi.widgetDeleteError': 'Suppression impossible.',
  'institution.bi.reorderError': 'Impossible de réordonner les blocs.',
  'institution.bi.newDashboard': 'Nouveau tableau',
  'institution.bi.dashboardList': 'Mes tableaux',
  'institution.bi.emptyList': 'Aucun tableau pour l’instant. Créez-en un pour commencer.',
  'institution.bi.emptyFiltered': 'Aucun tableau ne correspond aux filtres. Réinitialisez les filtres ou créez un tableau.',
  'institution.bi.selectDashboardPlaceholder': 'Choisir un tableau…',
  'institution.bi.pickDashboard':
    'Sélectionnez un tableau dans la liste déroulante ou créez-en un avec « Nouveau tableau ».',
  'institution.bi.rename': 'Renommer',
  'institution.bi.reloadData': 'Recharger les données',
  'institution.bi.addWidget': 'Ajouter un graphique',
  'institution.bi.noWidgets': 'Ce tableau est vide. Ajoutez un graphique ou un tableau.',
  'institution.bi.dashboardTitle': 'Titre',
  'institution.bi.dashboardDescription': 'Description',
  'institution.bi.groupsVisibility': 'Groupes d’apprenants (visibilité)',
  'institution.bi.groupsVisibilityHint':
    'Si aucun groupe n’est coché, tout utilisateur habilité au studio BI peut voir ce tableau. Sinon, seuls les comptes dont le participant (même e-mail) est membre d’au moins un des groupes choisis y ont accès — les rôles admin établissement, DRH et RH voient toujours tous les tableaux.',
  'institution.bi.categoriesLabel': 'Catégories',
  'institution.bi.categoriesHint': 'Permet de classer le tableau et de le retrouver avec le filtre catégories.',
  'institution.bi.filterByGroup': 'Filtrer par groupe',
  'institution.bi.filterByCategory': 'Filtrer par catégorie',
  'institution.bi.filterAll': 'Tous',
  'institution.bi.editDashboard': 'Modifier le tableau',
  'institution.bi.noGroupsInInstitution': 'Aucun groupe — créez-en dans la gestion des groupes.',
  'institution.bi.noCategoriesInInstitution': 'Aucune catégorie — créez-en dans l’onglet catégories des formations.',
  'institution.bi.multiSelectHint':
    'Ouvrez chaque liste pour cocher ou décocher ; utilisez la recherche pour trouver un libellé. Les deux filtres se cumulent.',
  'institution.bi.filterAllGroupsSummary': 'Tous les groupes',
  'institution.bi.filterAllCategoriesSummary': 'Toutes les catégories',
  'institution.bi.filterSearchInList': 'Rechercher…',
  'institution.bi.filterListNoResults': 'Aucun résultat',
  'institution.bi.filterSelectedMany': '{{count}} sélectionnés',
  'institution.bi.filterRemoveChipAria': 'Retirer {{name}} du filtre',
  'institution.bi.create': 'Créer',
  'institution.bi.dataset': 'Jeu de données',
  'institution.bi.visualization': 'Visualisation',
  'institution.bi.widgetTitle': 'Titre du bloc',
  'institution.bi.add': 'Ajouter',
  'institution.bi.deleteDashboard': 'Supprimer le tableau',
  'institution.bi.deleteWidget': 'Supprimer le widget',
  'institution.bi.hintDrag': 'Glissez les poignées pour réordonner les blocs.',
  'institution.bi.editWidget': 'Paramètres du bloc',
  'institution.bi.saveConfig': 'Enregistrer les paramètres',
  'institution.bi.configAdvanced': 'Paramètres avancés',
  'institution.bi.limit': 'Nombre de lignes / barres (max)',
  'institution.bi.kpiPick': 'Indicateurs affichés',
  'institution.bi.columnsPick': 'Colonnes du tableau',
  'institution.bi.colorsHint': 'Couleurs des séries (hex, une par ligne, ex. #001B3D)',
  'institution.bi.seriesColors': 'Palette',
  'institution.bi.barMetric': 'Mesure (histogramme)',
  'institution.bi.gridWidth': 'Largeur sur la grille',
  'institution.bi.gridHalf': 'Demi-largeur',
  'institution.bi.gridFull': 'Pleine largeur',
  'institution.bi.noData': 'Aucune donnée à afficher.',
  'institution.bi.noNonZeroPie': 'Aucune valeur non nulle.',
  'institution.bi.widgetType.kpi': 'Indicateurs',
  'institution.bi.widgetType.bar': 'Histogramme',
  'institution.bi.widgetType.line': 'Courbes',
  'institution.bi.widgetType.pie': 'Camembert',
  'institution.bi.widgetType.table': 'Tableau',
  'institution.bi.dataset.unknown': 'Jeu de données',
  'institution.bi.dataset.unknownDesc': '',
  'institution.bi.dataset.summary_kpis': 'Indicateurs clés',
  'institution.bi.dataset.summary_kpisDesc': 'Totaux apprenants, inscriptions, taux de complétion, etc.',
  'institution.bi.dataset.by_status': 'Répartition par statut',
  'institution.bi.dataset.by_statusDesc': 'Actifs, inactifs, parcours terminés.',
  'institution.bi.dataset.progress_distribution': 'Progression par tranche',
  'institution.bi.dataset.progress_distributionDesc':
    'Répartition des apprenants selon l’avancement sur leurs inscriptions.',
  'institution.bi.dataset.top_flows': 'Formations les plus suivies',
  'institution.bi.dataset.top_flowsDesc': 'Volumes d’inscriptions et complétions par parcours.',
  'institution.bi.dataset.activity_weeks': 'Activité sur 8 semaines',
  'institution.bi.dataset.activity_weeksDesc': 'Inscriptions actives et complétions par semaine.',
  'institution.bi.dataset.enrollments_detail': 'Détail des inscriptions',
  'institution.bi.dataset.enrollments_detailDesc': 'Tableau ligne par inscription.',
  'institution.bi.dataset.groups_overview': 'Groupes d’apprenants',
  'institution.bi.dataset.groups_overviewDesc': 'Effectifs par groupe de l’établissement.',
  'institution.bi.dataset.flows_overview': 'Formations (catalogue concepteur)',
  'institution.bi.dataset.flows_overviewDesc': 'Parcours de formation des collaborateurs de l’établissement et inscriptions.',
  'institution.bi.dataset.webinars_status': 'Webinaires par statut',
  'institution.bi.dataset.webinars_statusDesc': 'Nombre de sessions webinaire par état (brouillon, planifié, etc.).',
  'institution.bi.dataset.webinars_list': 'Liste des webinaires',
  'institution.bi.dataset.webinars_listDesc': 'Dernières sessions avec titre, statut et dates.',
  'institution.bi.dataset.explore_chart': 'Graphique personnalisé (données)',
  'institution.bi.dataset.explore_chartDesc':
    'Choisissez une source, une dimension (axe / regroupement) et une ou plusieurs mesures (comptage, somme, moyenne) sur des colonnes autorisées.',
  'institution.bi.explore.source.enrollments_detail': 'Inscriptions (détail)',
  'institution.bi.explore.source.groups_overview': 'Groupes',
  'institution.bi.explore.source.flows_overview': 'Formations (parcours)',
  'institution.bi.explore.source.webinars_list': 'Webinaires (liste)',
  'institution.bi.explore.dataSource': 'Source des données',
  'institution.bi.explore.dimension': 'Dimension (axe X / regroupement)',
  'institution.bi.explore.measures': 'Mesures (séries)',
  'institution.bi.explore.measureAgg': 'Agrégation',
  'institution.bi.explore.addMeasure': 'Ajouter une mesure',
  'institution.bi.explore.removeMeasure': 'Retirer',
  'institution.bi.explore.agg.count': 'Nombre de lignes',
  'institution.bi.explore.agg.sum': 'Somme',
  'institution.bi.explore.agg.avg': 'Moyenne',
  'institution.bi.explore.columnForAgg': 'Colonne',
  'institution.bi.explore.seriesKey': 'Clé de série (identifiant technique)',
  'institution.bi.explore.pieNote': 'Le camembert utilise uniquement la première mesure.',
  'institution.bi.explore.maxMeasures': 'Jusqu’à 4 mesures.',
  'institution.bi.explore.fullscreenTitle': 'Composer le graphique personnalisé',
  'institution.bi.explore.previewSectionTitle': 'Aperçu',
  'institution.bi.explore.previewLoading': 'Chargement des données…',
  'institution.bi.explore.previewHint': 'L’aperçu se met à jour automatiquement selon vos paramètres.',
  'institution.bi.explore.escapeHint': 'Échap pour fermer',
  'institution.bi.kpi.totalLearners': 'Apprenants',
  'institution.bi.kpi.totalEnrollments': 'Inscriptions',
  'institution.bi.kpi.completedEnrollments': 'Inscriptions terminées',
  'institution.bi.kpi.avgCompletionRate': 'Taux de complétion (%)',
  'institution.bi.kpi.totalTimeSpentSeconds': 'Temps total (s)',
  'institution.bi.kpi.activeLearners': 'Actifs (30 j.)',
  'institution.bi.kpi.inactiveLearners': 'Inactifs',
  'institution.bi.kpi.completedLearners': 'Parcours terminés',
  'institution.bi.column.participantId': 'ID participant',
  'institution.bi.column.name': 'Nom',
  'institution.bi.column.email': 'E-mail',
  'institution.bi.column.groups': 'Groupes',
  'institution.bi.column.flowId': 'ID parcours',
  'institution.bi.column.flowTitle': 'Formation',
  'institution.bi.column.completed': 'Terminé',
  'institution.bi.column.startedAt': 'Début',
  'institution.bi.column.completedAt': 'Fin',
  'institution.bi.column.lastAccessAt': 'Dernier accès',
  'institution.bi.column.totalTimeSpentSeconds': 'Temps (s)',
  'institution.bi.column.id': 'Identifiant',
  'institution.bi.column.title': 'Titre',
  'institution.bi.column.status': 'Statut',
  'institution.bi.column.scheduledStartAt': 'Début planifié',
  'institution.bi.column.createdAt': 'Créé le',
  'institution.bi.column.groupId': 'ID groupe',
  'institution.bi.column.membersCount': 'Membres',
  'institution.bi.column.description': 'Description',
  'institution.bi.column.enrollments': 'Inscriptions',
  'institution.bi.barMetric.enrollments': 'Inscriptions',
  'institution.bi.barMetric.completed': 'Terminées',
  'institution.bi.barMetric.completionRate': 'Taux de complétion (%)',
};

export const institutionBiStringsEn: Record<string, string> = {
  'institution.learnerAnalytics.biStudioBanner':
    'This is the standard analytics view. To build your own dashboards (multiple boards, custom charts, advanced options), open BI Studio in the left menu: the “BI dashboards” tab, just below “Learner analytics”.',
  'institution.learnerAnalytics.openBiStudio': 'Open BI studio — my dashboards',
  'institution.bi.title': 'Analytics dashboards',
  'institution.bi.subtitle':
    'Create multiple dashboards and compose charts and tables from your institution’s data (curated datasets).',
  'institution.bi.loadError': 'Could not load BI.',
  'institution.bi.dataError': 'Could not load dashboard data.',
  'institution.bi.defaultDashboardTitle': 'New dashboard',
  'institution.bi.createError': 'Could not create.',
  'institution.bi.deleteError': 'Could not delete.',
  'institution.bi.confirmDeleteDashboard': 'Delete this dashboard?',
  'institution.bi.toast.dashboardRemoved': 'Dashboard removed.',
  'institution.bi.toast.widgetRemoved': 'Chart removed from the dashboard.',
  'institution.bi.renameError': 'Could not save.',
  'institution.bi.widgetAddError': 'Could not add widget.',
  'institution.bi.confirmDeleteWidget': 'Remove this chart?',
  'institution.bi.widgetDeleteError': 'Could not delete.',
  'institution.bi.reorderError': 'Could not reorder widgets.',
  'institution.bi.newDashboard': 'New dashboard',
  'institution.bi.dashboardList': 'My dashboards',
  'institution.bi.emptyList': 'No dashboards yet. Create one to get started.',
  'institution.bi.emptyFiltered': 'No dashboards match the filters. Clear the filters or create a dashboard.',
  'institution.bi.selectDashboardPlaceholder': 'Choose a dashboard…',
  'institution.bi.pickDashboard': 'Select a dashboard from the dropdown or create one with “New dashboard”.',
  'institution.bi.rename': 'Rename',
  'institution.bi.reloadData': 'Reload data',
  'institution.bi.addWidget': 'Add chart',
  'institution.bi.noWidgets': 'This dashboard is empty. Add a chart or table.',
  'institution.bi.dashboardTitle': 'Title',
  'institution.bi.dashboardDescription': 'Description',
  'institution.bi.groupsVisibility': 'Learner groups (visibility)',
  'institution.bi.groupsVisibilityHint':
    'If no group is selected, any user with BI access can see this dashboard. Otherwise, only accounts whose participant (same email) belongs to at least one selected group can see it — institution admin, HRD and HR roles always see every dashboard.',
  'institution.bi.categoriesLabel': 'Categories',
  'institution.bi.categoriesHint': 'Organize the dashboard and find it with the category filter.',
  'institution.bi.filterByGroup': 'Filter by group',
  'institution.bi.filterByCategory': 'Filter by category',
  'institution.bi.filterAll': 'All',
  'institution.bi.editDashboard': 'Edit dashboard',
  'institution.bi.noGroupsInInstitution': 'No groups yet — create some in group management.',
  'institution.bi.noCategoriesInInstitution': 'No categories yet — create training categories first.',
  'institution.bi.multiSelectHint':
    'Open each list to tick or untick options; use search to find a label. Both filters combine.',
  'institution.bi.filterAllGroupsSummary': 'All groups',
  'institution.bi.filterAllCategoriesSummary': 'All categories',
  'institution.bi.filterSearchInList': 'Search…',
  'institution.bi.filterListNoResults': 'No matches',
  'institution.bi.filterSelectedMany': '{{count}} selected',
  'institution.bi.filterRemoveChipAria': 'Remove {{name}} from filter',
  'institution.bi.create': 'Create',
  'institution.bi.dataset': 'Dataset',
  'institution.bi.visualization': 'Visualization',
  'institution.bi.widgetTitle': 'Block title',
  'institution.bi.add': 'Add',
  'institution.bi.deleteDashboard': 'Delete dashboard',
  'institution.bi.deleteWidget': 'Remove widget',
  'institution.bi.hintDrag': 'Drag handles to reorder blocks.',
  'institution.bi.editWidget': 'Block settings',
  'institution.bi.saveConfig': 'Save settings',
  'institution.bi.configAdvanced': 'Advanced settings',
  'institution.bi.limit': 'Row / bar count (max)',
  'institution.bi.kpiPick': 'KPIs to show',
  'institution.bi.columnsPick': 'Table columns',
  'institution.bi.colorsHint': 'Series colors (hex, one per line, e.g. #001B3D)',
  'institution.bi.seriesColors': 'Palette',
  'institution.bi.barMetric': 'Bar metric',
  'institution.bi.gridWidth': 'Grid width',
  'institution.bi.gridHalf': 'Half width',
  'institution.bi.gridFull': 'Full width',
  'institution.bi.noData': 'No data to display.',
  'institution.bi.noNonZeroPie': 'No non-zero values.',
  'institution.bi.widgetType.kpi': 'KPIs',
  'institution.bi.widgetType.bar': 'Bar chart',
  'institution.bi.widgetType.line': 'Line chart',
  'institution.bi.widgetType.pie': 'Pie chart',
  'institution.bi.widgetType.table': 'Table',
  'institution.bi.dataset.unknown': 'Dataset',
  'institution.bi.dataset.unknownDesc': '',
  'institution.bi.dataset.summary_kpis': 'Key indicators',
  'institution.bi.dataset.summary_kpisDesc': 'Learner totals, enrollments, completion rate, etc.',
  'institution.bi.dataset.by_status': 'Status breakdown',
  'institution.bi.dataset.by_statusDesc': 'Active, inactive, completed paths.',
  'institution.bi.dataset.progress_distribution': 'Progress bands',
  'institution.bi.dataset.progress_distributionDesc': 'Learners by progress band across their enrollments.',
  'institution.bi.dataset.top_flows': 'Top courses',
  'institution.bi.dataset.top_flowsDesc': 'Enrollment and completion volumes per path.',
  'institution.bi.dataset.activity_weeks': '8-week activity',
  'institution.bi.dataset.activity_weeksDesc': 'Active enrollments and completions per week.',
  'institution.bi.dataset.enrollments_detail': 'Enrollment detail',
  'institution.bi.dataset.enrollments_detailDesc': 'One row per enrollment.',
  'institution.bi.dataset.groups_overview': 'Learner groups',
  'institution.bi.dataset.groups_overviewDesc': 'Member counts per group.',
  'institution.bi.dataset.flows_overview': 'Courses (designer catalog)',
  'institution.bi.dataset.flows_overviewDesc': 'Training paths owned by institution designers and enrollments.',
  'institution.bi.dataset.webinars_status': 'Webinars by status',
  'institution.bi.dataset.webinars_statusDesc': 'Session counts by state (draft, scheduled, etc.).',
  'institution.bi.dataset.webinars_list': 'Webinar list',
  'institution.bi.dataset.webinars_listDesc': 'Recent sessions with title, status and dates.',
  'institution.bi.dataset.explore_chart': 'Custom chart (data)',
  'institution.bi.dataset.explore_chartDesc':
    'Pick a source, a dimension (X axis / grouping), and one or more measures (count, sum, average) on allowed columns.',
  'institution.bi.explore.source.enrollments_detail': 'Enrollments (detail)',
  'institution.bi.explore.source.groups_overview': 'Groups',
  'institution.bi.explore.source.flows_overview': 'Courses (paths)',
  'institution.bi.explore.source.webinars_list': 'Webinars (list)',
  'institution.bi.explore.dataSource': 'Data source',
  'institution.bi.explore.dimension': 'Dimension (X axis / grouping)',
  'institution.bi.explore.measures': 'Measures (series)',
  'institution.bi.explore.measureAgg': 'Aggregation',
  'institution.bi.explore.addMeasure': 'Add measure',
  'institution.bi.explore.removeMeasure': 'Remove',
  'institution.bi.explore.agg.count': 'Row count',
  'institution.bi.explore.agg.sum': 'Sum',
  'institution.bi.explore.agg.avg': 'Average',
  'institution.bi.explore.columnForAgg': 'Column',
  'institution.bi.explore.seriesKey': 'Series key (technical id)',
  'institution.bi.explore.pieNote': 'Pie charts use only the first measure.',
  'institution.bi.explore.maxMeasures': 'Up to 4 measures.',
  'institution.bi.explore.fullscreenTitle': 'Build your custom chart',
  'institution.bi.explore.previewSectionTitle': 'Preview',
  'institution.bi.explore.previewLoading': 'Loading data…',
  'institution.bi.explore.previewHint': 'The preview updates automatically as you change settings.',
  'institution.bi.explore.escapeHint': 'Esc to close',
  'institution.bi.kpi.totalLearners': 'Learners',
  'institution.bi.kpi.totalEnrollments': 'Enrollments',
  'institution.bi.kpi.completedEnrollments': 'Completed enrollments',
  'institution.bi.kpi.avgCompletionRate': 'Completion rate (%)',
  'institution.bi.kpi.totalTimeSpentSeconds': 'Total time (s)',
  'institution.bi.kpi.activeLearners': 'Active (30d)',
  'institution.bi.kpi.inactiveLearners': 'Inactive',
  'institution.bi.kpi.completedLearners': 'Paths completed',
  'institution.bi.column.participantId': 'Participant ID',
  'institution.bi.column.name': 'Name',
  'institution.bi.column.email': 'Email',
  'institution.bi.column.groups': 'Groups',
  'institution.bi.column.flowId': 'Path ID',
  'institution.bi.column.flowTitle': 'Course',
  'institution.bi.column.completed': 'Completed',
  'institution.bi.column.startedAt': 'Started',
  'institution.bi.column.completedAt': 'Finished',
  'institution.bi.column.lastAccessAt': 'Last access',
  'institution.bi.column.totalTimeSpentSeconds': 'Time (s)',
  'institution.bi.column.id': 'ID',
  'institution.bi.column.title': 'Title',
  'institution.bi.column.status': 'Status',
  'institution.bi.column.scheduledStartAt': 'Scheduled start',
  'institution.bi.column.createdAt': 'Created',
  'institution.bi.column.groupId': 'Group ID',
  'institution.bi.column.membersCount': 'Members',
  'institution.bi.column.description': 'Description',
  'institution.bi.column.enrollments': 'Enrollments',
  'institution.bi.barMetric.enrollments': 'Enrollments',
  'institution.bi.barMetric.completed': 'Completed',
  'institution.bi.barMetric.completionRate': 'Completion rate (%)',
};
